(function termsAndConditionsControlModuleDefinition() {
    'use strict';

    angular.module('TermsAndConditionsControl', [])
        .directive('termsAndConditionsControl', ['$translate', 'errorsExtend', '$state', '$stateParams', 'authExtend', '$uibModal', 'notificationService', '$httpBackend', '$rootScope',
            function ($translate, errors, $state, $stateParams, authExtend, $modal, notificationService, $httpBackend, $rootScope) {
                return {
                    scope: {
                        acceptCallback: '&'
                    },
                    link: function (scope, element, attrs) {
                    },
                    controller: [
                        '$scope', '$element', function ($scope) {

                            $scope.load = function () {
                                $scope.aux = {
                                    id: undefined,
                                    body: '',
                                    title: '',
                                    approved: false
                                }

                                $scope.organizationalUnitId = authExtend.getOrganizationId();
                                $scope.userId = authExtend.getUserId();
                                
                                notificationService.getNotification('popup', $scope.organizationalUnitId, $scope.userId, true).then(function (result) {
                                    $scope.aux = result[0];
                                    if ($scope.aux) {
                                        var modalInstance = $modal.open({
                                            templateUrl: '/app/directives/terms-and-conditions-control/terms-and-conditions-control.html',
                                            size: 'lg',
                                            backdrop: 'static',
                                            keyboard: false,
                                            resolve: {
                                                aux: function () {
                                                    return $scope.aux;
                                                }
                                            },
                                            controller: [
                                                '$scope', 'aux', function ($scope, aux) {

                                                    $scope.aux = aux;

                                                    $scope.accept = function () {
                                                        $scope.aux.approved = true;
                                                        modalInstance.close($scope.aux);
                                                    }

                                                    $scope.cancel = function () {
                                                        modalInstance.close($scope.aux);
                                                    }
                                                }]
                                        });

                                        modalInstance.result.then(function (result) {
                                            if (result && result.approved) {
                                                notificationService.approve(result.id).then(function (result) {
                                                    $scope.acceptCallback();
                                                }, function (error) {
                                                    errors.showError(error);
                                                });
                                            }
                                            else {
                                                authExtend.logout();
                                                $state.go('inicio');
                                            }
                                        });
                                    }
                                }, function (error) {
                                    errors.showError(error);
                                });
                            };

                            $scope.load();
                        }],
                    restrict: 'E'
                };
            }
        ]);
})();